<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">搜索结果</div>
        <Search :search="nationList" :page="page" @sizeChange="sizeChange" @currentChange="currentChange" />
        <empty class="empty-margin" v-if="nationList.length <= 0"></empty>
      </div>
    </div>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import { getSearchList } from '@/api/home'
import empty from "@/components/empty/index";
import Search from "@/components/search/index.vue";

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, empty, Search },
  data() {
    return {
      selectedIndex: null,
      nationList: [],
      page: {
        number: 1,
        limit: 10,
        total: 0,
      },
      searchTitle: '',
    }
  },
  watch: {
    "$route" (to, from) {
      this.searchTitle = to.query.title ? to.query.title : ''
      this.page.number = 1
      this.getSearchList()
    },
  },
  methods: {
    // 获取搜索列表
    async getSearchList () {
      await getSearchList({
        number: this.page.number,
        limit: this.page.limit,
        checkStatus: "HAVE_RELEASED",
        title: this.searchTitle
      }).then(res => {
        this.nationList = res.data
        this.page.total = res.totalCount
      })
    },
    sizeChange(value) {
      this.page.number = 1
      this.page.limit = value
      this.getSearchList()
    },
    currentChange(value) {
      this.page.number = value
      this.getSearchList()
    },
  },
  async mounted() {
    if (this.$route.query.title) {
      this.searchTitle = this.$route.query.title
    }
    await this.getSearchList()
  }
}
</script>

<style lang="less" scoped>
.center-box {
  padding-bottom: 80px;
}

/deep/.el-input__inner {
  // height: 32px;
  // border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  // color: rgba(0, 0, 0, 0.45) !important;
  // line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/index.vue